import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BeraterEnvironmentService } from '../environment/berater-environment.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private envService = inject(BeraterEnvironmentService);
  protected httpClient = inject(HttpClient);
  protected apiUrl = this.envService.getApiUrl();
}
